export default {
  GET_EXAMPLE_STATE: (state) => state.exampleState,
  GET_ALGORITHM_QUESTION_DATA: (state) => state.algorithmQuestionData,
  token: (state) => state.token,
  auth: (state) => state.auth,
};
